import { createFeatureSelector } from '@ngrx/store';

export const currentLocationState = createFeatureSelector<OLO.State, OLO.State.CurrentLocation>('currentLocation');
